import { render, staticRenderFns } from "./LeadForm.vue?vue&type=template&id=45814841&scoped=true"
import script from "./LeadForm.vue?vue&type=script&lang=js"
export * from "./LeadForm.vue?vue&type=script&lang=js"
import style0 from "./LeadForm.vue?vue&type=style&index=0&id=45814841&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45814841",
  null
  
)

export default component.exports